export default __webpack_public_path__ + "static/media/arrow-r.af5e5787.svg";